import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

export const DesktopNavbarGrid = styled.div`
  display: none;
  @media (min-width: 992px) {
    display: grid;
    grid-template-columns: 1fr auto;
    align-items: center;
    gap: 0.5rem;
  }

  & > div:first-child {
    .btn,
    a.btn {
      flex-shrink: 1;
      min-width: 0;
      white-space: nowrap;
      overflow: hidden;
    }

    .btn > span,
    a.btn > span {
      overflow: hidden;
      text-overflow: ellipsis;
      display: inline-block;
      vertical-align: middle;
    }
  }
`;

export const ContainerBusca = styled.div`
  position: relative;
  z-index: 20;
  background: #fff;
  padding: 2rem 0;

  .drop-corretor {
  }
`;

export const DropdownCorretor = styled(Dropdown)`
  z-index: 1010;
  @media (min-width: 992px) {
    z-index: 1040;
  }

  .dropdown-menu {
    &::before {
      position: absolute;
      z-index: 10;
      bottom: 0;
      width: 100%;
      height: 50px;
      content: '';
      display: block;
      background: linear-gradient(180deg, transparent, #fff 70%);
    }
  }
`;
